<template>
  <div>
    <!--blog Section start-->
    <div class="page-margin">
      <!--breadcrumb start-->
      <div class="breadcrumb-bg">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-text-center d-align-center">
              <h2 class="title">Sobre o<span> sistema</span></h2>
            </div>
          </div>
        </div>
      </div>
      <!--breadcrumb end -->

      <!--blog Section start-->
      <section style="padding-top: 10px;">
        <div class="container">
          <div class="blog-text">
            <h3 class="blog-head">Nosso sistema é completo e auto instalável, simples de usar e
              atende a todas as necessidades de emissão de documentos fiscais eletrônicos. </h3>
            <div class="blog-description">
              <p> ( NFC-e, NF-e, SAT, MF-e, MDF-e e CT-e).</p>
            </div>
            <div class="blog-divider"></div>
          </div>
          <div class="row">
            <div class="col-md-8 col-lg-9 blog-sec mt-3">
              <ul class="feature-style row m-2">
                <li class="col-12 col-md-6" v-for="(item, index) in features" :key="index">
                  <div class="feature-icon">
                    <img :src='item.img' width="64" alt="icon">
                  </div>
                  <div class="feature-subtitle">
                    <h3>{{ item.title }}</h3>
                  </div>
                  <div>
                    <p v-html="item.desc"></p>
                  </div>
                </li>
              </ul>
            </div>
            <!-- sidebar section -->
            <div class="col-md-4 col-lg-3 order-md-last list-sidebar">
              <div class="sidebar">
                <div class="sidebar-space">
                  <h4 class="blog-title">REQUISITOS MÍNIMOS</h4>
                  <div class="blog-divider"></div>
                  <div class="blog-cat-detail">
                    <ul>
                      <li class="marg-15">
                        Sistema Operacional: Windows 10.
                      </li>
                      <li class="marg-15">
                        Navegador de Internet (Internet Explorer, Google Chrome, Mozilla Firefox, etc.)
                      </li>
                      <li class="marg-15">
                        300 MB de espaço em disco (Disco Rígido).
                      </li>
                      <li class="marg-15">
                        1 GB de Memória RAM.
                      </li>
                      <li class="marg-15">
                        Mouse ou dispositivo apontador compatível.
                      </li>
                      <li class="marg-15">
                        Monitor super VGA ou superior, com resolução mínima de 1280 x 768 pixels.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="sidebar-space">
                  <h4 class="blog-title">OBSERVAÇÕES</h4>
                  <div class="blog-divider"></div>
                  <div class="blog-cat-detail">
                    Quanto mais recursos (memória e processamento) forem colocados à
                    disposição, melhor será o desempenho do sistema. É necessário
                    que o seu usuário do Windows tenha permissões totais de Administrador.
                  </div>
                </div>
              </div>
            </div>
            <!-- sidebar section -->
          </div>
        </div>
      </section>
      <!--blog Section End-->

      <!--Footer Section start-->
      <Footer />
      <js />
      <!--Footer Section End-->

    </div>
    <!-- blog Section end -->
  </div>
</template>
<script>
export default {
  name: 'Blog_details',
  data() {
    return {
      features: [
        {
          title: 'PDV',
          img: require("../assets/img/PDV-2020-72.png"),
          desc: `É muito fácil de utilizar nosso PDV, podendo emitir NFC-e, SAT (SP) e MFE (CE)
                          Pedido de Venda<br>
                          Abertura e fechamento sem limite diário<br>
                          Recebimento de contas integrado<br>
                          Emissão de Orçamentos<br>
                          Integração com TEF<br>
                          Integração com balança e gaveta`
        },
        {
          title: 'CADASTRO DE PESSOAS',
          img: require("../assets/img/Icones-Entrada-2020-72.png"),
          desc: `Com este módulo será muito simples manter o cadastro de clientes e fornecedores da sua empresa sempre atualizados.<br>
                 O sistema trabalha com um buscador automático de dados, com o preenchimento completo do cadastro quando localizado.`
        },
        {
          title: 'CONTAS A RECEBER',
          img: require("../assets/img/Receber-2020-72.png"),
          desc: `Você poderá controlar em tempo real suas cobranças, imprimir boletos de cobrança ou enviá-los por e-mail.<br>
                 Além de gerar inúmeros relatórios que irão facilitar o controle da empresa.`
        },
        {
          title: 'CONTAS A PAGAR',
          img: require("../assets/img/Pagar-2020-72.png"),
          desc: `Sua empresa vai poder manter um histórico das contas a pagar a vencer, vencidas, quitadas e atrasadas.<br>
                 Além de gerar inúmeros relatórios que irão facilitar o controle da empresa.`
        },
        {
          title: 'CONTROLE DE ESTOQUE',
          img: require("../assets/img/Estoque-2020-72.png"),
          desc: `Será fácil organizar, controlar e classificar os produtos do seu estoque.<br>
                 Poderá trabalhar com grades, números de série e foto nos produtos.<br>
                 Pode configurar preço de atacado e varejo`
        },
        {
          title: 'LIVRO CAIXA',
          img: require("../assets/img/Caixa-2020-72.png"),
          desc: `Módulo funciona integrado ao restante do sistema desta forma as informações são preenchidas de forma praticamente automática.<br>
                 Acompanhe todo histórico financeiro de entradas e saídas de valores da empresa tudo estará alimentado neste módulo.`
        },
        {
          title: 'NOTA FISCAL ELETRÔNICA',
          img: require("../assets/img/NFe-2020-72.png"),
          desc: `Será fácil trabalhar com NF-e de entrada, saída e devolução.<br>
                 Envio da DANFE por e-mail.<br>
                 É muito simples fazer o Cancelamento e Inutilização da NF-e.<br>
                 Manifestação do destinatário.<br>
                 Importação automática do XML da NF-e de entrada.`
        },
        {
          title: 'CONHECIMENTO DE TRANSPORTE ELETRÔNICO',
          img: require("../assets/img/CTe-2020-64.png"),
          desc: `Autorize a saída de seus veículos rapidamente emitindo seu CT-e em apenas alguns segundos.<br>
                 Importação de XML.<br>
                 Importação de NFe via chave de acesso.`
        },
        {
          title: 'MANISFESTO DE DOCUMENTO FISCAL ELETRÔNICO',
          img: require("../assets/img/NDFe-2020-72.png"),
          desc: `Importe as NF-es e CT-es direto no MDF-e.<br>
                 Gestão facilitada de suas emissões, ações como cancelamento, encerramento e inclusão de condutor em poucos cliques.`
        },
        {
          title: 'SISTEMA PÚBLICO DE ESCRITURAÇÃO DIGITAL(SPED)',
          img: require("../assets/img/Sped-2020-72.png"),
          desc: `A Escrituração Fiscal Digital – EFD é um arquivo digital, que se constitui de um conjunto de escriturações de documentos fiscais e de outras informações de interesse dos fiscos das unidades federadas e da Secretaria da Receita Federal do Brasil, bem como de registros de apuração de impostos referentes às operações e prestações praticadas pelo contribuinte.`
        },
        {
          title: 'SINTEGRA',
          img: require("../assets/img/Sintegra-2020-72.png"),
          desc: `Sintegra é o meio facilitador do acesso às informações de entradas e saídas da empresa para o Fisco. É dessa forma que o poder público obtém um controle mais apurado sobre as operações que ocorrem nas organizações.`
        }
      ],
    }
  }
}
</script>
<style scoped>
.feature-style p {
  font-size: 11px !important;
}

.feature-style li {
  margin-bottom: 20px !important;
}

.blog-cat-detail {
  font-size: 12px;
  color: #777;
}

.feature-subtitle h3 {
  padding-left: 60px;
  margin-top: 25px;
  margin-bottom: 20px;
}

.feature-icon {
  position: absolute;
  padding: 0;
  /* top: -25px; */
  left: 5px;
}

.row h3 {
  color: #18e7d3;
}

a h3 {
  margin-top: 0;
  padding: 1rem;
  padding-top: 0;
}

a h3:hover {
  color: #137d8b;
}

@media (max-width: 1366px) {
  .feature-phone img {
    height: 420px;
    margin-top: 2rem;
    margin-left: -1rem;
    width: 100%;
  }
}

@media (min-width: 1600px) {
  .feature-style p {
    font-size: 14px !important;
  }

  .blog-cat-detail {
    font-size: 15px;
  }

  .feature-subtitle h3 {
    font-size: 25px;
  }
}

.feature-decor .feature-circle1 {
  right: -14px;
  bottom: 198px;
}
</style>



// WEBPACK FOOTER //
// src/components/more.vue